<template>
  <div class="event-details smooth-shadow">
    <div class="header">
      <h2 class="title">Entity Details</h2>
    </div>
    <div class="table-wrapper">
      <Table
        :headers="getHeaders"
        :rows="getDetails"
        :showFilters="false"
        :loadingData="isDetailsLoading"
        @onLoadMore="handleLoadMore"
        @onFilterChange="handleFilterChange"
      />
      <!-- @onSortChange="handleSortChange" -->
    </div>
  </div>
</template>

<script>
import Table from "@/components/static_entity_analysis/views/Table";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Table,
  },
  data() {
    return {
      isDetailsLoading: false,
      details: [],
      detailsPageNumber: 1,
      detailsTotalPages: null,
    };
  },
  computed: {
    getEntityId() {
      return this.$route.params.entity_id;
    },
    getEntityItemId() {
      return this.$route.params.item_id;
    },
    getHeaders() {
      if (this.details && this.details.length > 0) {
        return Object.keys(this.details[0]).map((columnId) => ({
          id: columnId,
          text: columnId.split("__")[1] || columnId,
        }));
      } else {
        return [];
      }
    },
    getDetails() {
      return this.details.map((row) =>
        Object.entries(row).reduce((obj, [key, value]) => {
          obj[key] = value || "-";
          return obj;
        }, {})
      );
    },
  },
  methods: {
    ...mapActions("Lookup", ["fetchEntityOverview"]),
    handleLoadMore() {
      console.log("LoadMore");
      if (
        this.detailsPageNumber < this.detailsTotalPages &&
        !this.isDetailsLoading
      ) {
        this.detailsPageNumber++;
        this.loadDetails();
      }
    },
    handleSortChange(newSort) {
      this.loadDetails({ sort: newSort, overwriteData: true });
    },
    handleFilterChange({ filter, heading }) {
      // TODO: Implement This:
      // this.toggleEntityFilter({ column: filter.column, value: filter.value });
      // this.loadDetails({ sort: filter, overwriteData: true });
    },
    async loadDetails({ sort, filter, overwriteData } = {}) {
      this.isDetailsLoading = true;

      if (overwriteData) this.detailsPageNumber = 1;

      try {
        // let payload =
        this.overviewData = await this.fetchEntityOverview({
          entity_id: this.getEntityId,
          entity_item_id: this.getEntityItemId,
          page_id: this.detailsPageNumber,
          columns: this.columns, // For meta data about event
          // filters: [this.col_filter],
          // time_filters: this.time_filters
          // What about sort?
          sort: sort,
          // filter: filter,
        });
        if (overwriteData) {
          this.details = this.overviewData.entity_details;
        } else {
          this.details.push(...this.overviewData.entity_details);
        }
        this.detailsTotalPages = this.overviewData.total_pages;
        this.isDetailsLoading = false;
      } catch (error) {
        console.error(error);
        this.isDetailsLoading = false;
      }
    },
  },
  mounted() {
    this.loadDetails();
  },
};
</script>

<style lang="scss" scoped>
.event-details {
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--border-color);
  padding: 15px 25px;

  .header {
    display: flex;
    align-items: center;

    .title {
      font-weight: bold;
      margin: 20px 0;
      margin-right: 50px;
    }
  }

  .table-wrapper {
    /* background: var(--color-default-background); */
    height: 500px;
  }
}
</style>
